import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ItemAddonResponse } from '@libs/shared/types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddonApiService {
  constructor(private httpClient: HttpClient) {}

  getAddons(baseApiUrl: string, itemId: string, merchantId: string): Observable<ItemAddonResponse> {
    return this.httpClient.get<ItemAddonResponse>(`${baseApiUrl}merchants/${merchantId}/items/${itemId}/addonInfo`);
  }
}
